// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__rQGlB","row":"Node_row__oBwwR","label":"Node_label__ZpaBl","footer":"Node_footer__27bxx"};